// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"371":"css/base_components","6010":"css/docstyle","6946":"css/it/style","8266":"css/style","8347":"css/appstyle"}[chunkId] + ".css";
};